import { DEFAULT_WIDTH } from "../../constants/layout.js";
import { getRouteBBox } from "../../utils/draw-relationship/index.js";
import { getActiveView, getSourceView } from "../../engine/modules/editor/view.js";
import { getMemoRect, getTableRect } from "./metrics.js";
//#region src/konva/scene/viewport.ts
function getActiveTransform(state) {
	return getActiveView(state) ?? state.settings;
}
function getSceneTransform(state, source = "document") {
	return getSourceView(state, source) ?? state.settings;
}
function getZoomTransform(state, source) {
	return source ? getSceneTransform(state, source) : getActiveTransform(state);
}
function getSceneOrigin({ originX, originY }) {
	return {
		x: originX,
		y: originY
	};
}
var safeZoom = (zoomLevel) => zoomLevel > 0 ? zoomLevel : 1;
function toScreenPoint(transform, point) {
	const origin = getSceneOrigin(transform);
	return {
		x: origin.x + point.x * transform.zoomLevel,
		y: origin.y + point.y * transform.zoomLevel
	};
}
function toScenePoint(transform, point) {
	const zoomLevel = safeZoom(transform.zoomLevel);
	const origin = getSceneOrigin({
		...transform,
		zoomLevel
	});
	return {
		x: (point.x - origin.x) / zoomLevel,
		y: (point.y - origin.y) / zoomLevel
	};
}
function getOriginToPlace(zoomLevel, scene, screen) {
	return {
		x: screen.x - scene.x * zoomLevel,
		y: screen.y - scene.y * zoomLevel
	};
}
function createCullingRect(options) {
	const { viewportWidth, viewportHeight } = options;
	const zoomLevel = safeZoom(options.zoomLevel);
	const origin = getSceneOrigin({
		...options,
		zoomLevel
	});
	const screenWidth = (viewportWidth > 0 ? viewportWidth : DEFAULT_WIDTH) / zoomLevel;
	const screenHeight = (viewportHeight > 0 ? viewportHeight : 675) / zoomLevel;
	return {
		x: -origin.x / zoomLevel - screenWidth,
		y: -origin.y / zoomLevel - screenHeight,
		width: screenWidth * 3,
		height: screenHeight * 3
	};
}
function getCullingRect(state, source = "document") {
	const { originX, originY, zoomLevel } = getSceneTransform(state, source);
	const { viewport } = state.editor;
	return createCullingRect({
		originX,
		originY,
		zoomLevel,
		viewportWidth: viewport.width,
		viewportHeight: viewport.height
	});
}
function intersects(rect, other) {
	return !(other.x > rect.x + rect.width || other.x + other.width < rect.x || other.y > rect.y + rect.height || other.y + other.height < rect.y);
}
function isTableVisible(rect, state, table, source = "document") {
	return intersects(rect, getTableRect(state, table, source));
}
function isMemoVisible(rect, memo) {
	return intersects(rect, getMemoRect(memo));
}
function isRelationshipVisible(rect, relationship, strokeWidth, source = "document") {
	return intersects(rect, getRouteBBox(relationship, strokeWidth, source));
}
//#endregion
export { createCullingRect, getActiveTransform, getCullingRect, getOriginToPlace, getSceneOrigin, getSceneTransform, getZoomTransform, intersects, isMemoVisible, isRelationshipVisible, isTableVisible, toScenePoint, toScreenPoint };
